// extracted by mini-css-extract-plugin
module.exports = {"pitLimiter":"pitLimiter","shouldShow":"shouldShow","max":"max","current":"current","warning":"warning"};